export const filesConsts = {
  FILE_SIZE_ALLOWED : 8388608,  //8 MB
  ONE_MB : 1048576,  //1 MB
};
